
import { BarChart3 } from 'lucide-react';
import { AnalyticsSidebar } from './components';
import { useSetPageTitle } from '@/hooks/use-page-title';

export default function AnalyticsLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  useSetPageTitle('Analytics', BarChart3);
  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex flex-1 overflow-hidden">
        <AnalyticsSidebar />
        <div className="flex-1 overflow-auto bg-muted/40 p-6">
          {children}
        </div>
      </div>
    </div>
  );
}
